/**
 * OCHRONA TREŚCI — kod JS, który administrator włącza suwakami w /admin/integrations
 * (karta „Monitoring aktywności"). Każdy suwak to OSOBNE zachowanie, włączane i zdejmowane niezależnie.
 *
 * [polecenie właściciela 2026-09-19] „blokowania F12, blokowania view-source, blokowania kopiowania tekstu
 * itp, jest za to odpowiedzialny kod JS który można dodać lub nie, zmiany mają mieć charakter globalny —
 * każdy taki przycisk oddzielny suwak".
 *
 * ⚠️ CO TE BLOKADY SĄ WARTE. Podnoszą próg, nie zamykają drogi. Przechwytujemy skrót klawiszowy albo
 * zdarzenie W OKNIE STRONY. Poza zasięgiem zostają: menu przeglądarki (⋮ → Więcej narzędzi → Narzędzia
 * dla programistów), narzędzia już otwarte przed wejściem na stronę, wyłączony JavaScript, zapis strony
 * z dysku i zakładka „Sieć" pokazująca surową odpowiedź serwera. Kto ma dane na ekranie, ma je też
 * w odpowiedzi API. To jest utrudnienie dla przypadkowego kopiowania, nie kontrola dostępu — dane,
 * których ktoś nie ma widzieć, odcina się ODEBRANIEM UPRAWNIENIA, nie tym modułem.
 *
 * ⚠️ ZRZUTU EKRANU NIE DA SIĘ ZABLOKOWAĆ ANI WYKRYĆ (powiedziane właścicielowi 17.09, paczka AN).
 * Klawisz PrintScreen obsługuje system operacyjny, nie przeglądarka — strona nie dostaje o nim zdarzenia,
 * a obraz i tak już powstał. Czarny obraz u Netflixa to DRM na ścieżce wideo (Widevine/EME): chroniony
 * strumień dekoduje się poza zasięgiem kompozytora, który wycina TEN prostokąt z bufora przechwytywania —
 * reszta strony Netflixa zrzuca się normalnie. Narzędzie Wycinanie, telefon i nagrywarka ekranu są poza
 * przeglądarką z definicji. Odpowiedzią na zrzuty jest ZNAK WODNY (components/OchronaTresci/ZnakWodny.js):
 * zrzut nadal powstanie, ale wskaże osobę, która go zrobiła. Tego modułu nie wolno rozbudować o suwak
 * „blokada zrzutów" — włączałby się i nie robił nic, a ktoś uznałby dane za chronione.
 *
 * ⚠️ DOSTĘPNOŚĆ. Blokada kopiowania zdejmuje zaznaczanie tekstu, a tekst, którego nie da się zaznaczyć, to
 * też tekst, którego nie przeczyta lupa, tłumacz strony ani czytanie na głos zaznaczenia. Dlatego:
 *  • POLA FORMULARZY, listy rozwijane i edytor treści działają BEZ ZMIAN — zaznaczanie, kopiowanie, wklejanie,
 *    menu kontekstowe i Ctrl+U (podkreślenie w edytorze) są w nich nietknięte;
 *  • wyjątek bierze się z jednego predykatu `czyPoleEdycji`, więc nie da się go zgubić w jednym z zachowań;
 *  • element oznaczony `data-bez-ochrony` też jest pominięty — to furtka dla miejsc, w których kopiowanie
 *    jest treścią funkcji (numer zgłoszenia, klucz licencji).
 * Czytnik ekranu czyta drzewo dostępności, nie zaznaczenie, więc jego blokada nie dotyczy.
 */

/** Zdarzenie na `window` po udanym zapisie suwaków — karta administratora nakłada zmianę bez przeładowania. */
export const ZDARZENIE_OCHRONY_TRESCI = "ochrona-tresci-zmiana";

/** Atrybut na `<body>` włączający regułę `user-select: none` (arkusz: components/OchronaTresci/OchronaTresci.module.css). */
export const ATRYBUT_KOPIOWANIA = "data-ochrona-kopiowanie";

/**
 * Klucz w `sessionStorage`: administrator sprawdza blokady NA SOBIE w tej jednej karcie.
 * Zasięg karty jest tu ochroną: zamknięcie karty kończy próbę, więc nie da się nią zablokować sobie F12 na stałe.
 * Flaga potrafi wyłącznie WŁĄCZYĆ blokady komuś, kto jest z nich zwolniony — nigdy ich nie zdejmuje.
 */
export const KLUCZ_PODGLADU_BLOKAD = "ochrona-tresci-sprawdzam-na-sobie";

/** Pola, w których niczego nie blokujemy. `select` też — Ctrl+C na wybranej pozycji jest normalną pracą. */
const POLA =
    "input, textarea, select, option, [contenteditable]:not([contenteditable='false']), [data-bez-ochrony], .ql-editor";

/** Czy zdarzenie wyszło z pola formularza / edytora (albo z czegoś oznaczonego `data-bez-ochrony`). */
export const czyPoleEdycji = (cel) => {
    const el = cel && cel.nodeType === 1 ? cel : cel?.parentElement;
    if (!el || typeof el.closest !== "function") return false;
    return !!el.closest(POLA);
};

/** Czy w tej karcie administrator sprawdza blokady na sobie. Brak pamięci przeglądarki = nie sprawdza. */
export const podgladBlokadWlasnych = () => {
    try {
        return window.sessionStorage.getItem(KLUCZ_PODGLADU_BLOKAD) === "1";
    } catch {
        return false;
    }
};

/** Włącza/wyłącza sprawdzanie na sobie w TEJ karcie i zwraca stan po zmianie. */
export const ustawPodgladBlokadWlasnych = (wlacz) => {
    try {
        if (wlacz) window.sessionStorage.setItem(KLUCZ_PODGLADU_BLOKAD, "1");
        else window.sessionStorage.removeItem(KLUCZ_PODGLADU_BLOKAD);
    } catch {
        return false;   // pamięć zablokowana — sprawdzanie na sobie po prostu nie działa
    }
    return !!wlacz;
};

/**
 * Czy nakładać blokady na TĘ przeglądarkę. Serwer mówi `blokadyStosowane` (ranga administratora = false),
 * a flaga karty potrafi je tylko DOŁOŻYĆ. Napisane jako alternatywa, nie koniunkcja — żeby nie dało się
 * ustawieniem w przeglądarce zdjąć sobie blokady, którą serwer nałożył.
 */
export const czyStosowacBlokady = (ustawienia) => ustawienia?.blokadyStosowane !== false || podgladBlokadWlasnych();

const zablokuj = (e) => {
    e.preventDefault();
    e.stopPropagation();
};

/**
 * Nakłada wybrane zachowania i zwraca funkcję, która zdejmuje DOKŁADNIE to, co nałożyła.
 * Wywołanie bez żadnego włączonego suwaka nie dokłada ani jednego nasłuchu — wyłączona ochrona ma nic nie kosztować.
 *
 * @param {{blokadaF12?: boolean, blokadaZrodla?: boolean, blokadaKopiowania?: boolean, blokadaMenuKontekstowego?: boolean}} ustawienia
 * @param {{okno?: Window, dokument?: Document}} [opcje] — wstrzyknięcie okna/dokumentu (testy, ramki).
 * @returns {() => void} zatrzymanie
 */
export const uruchomOchroneTresci = (ustawienia, opcje = {}) => {
    const u = ustawienia || {};
    const okno = opcje.okno || (typeof window !== "undefined" ? window : null);
    const dokument = opcje.dokument || okno?.document || null;
    if (!okno || !dokument) return () => {};

    const sprzatanie = [];

    const nasluch = (cel, nazwa, uchwyt) => {
        // Faza PRZECHWYTYWANIA: skrót ma zostać zatrzymany, zanim dobiegnie do komponentu,
        // który go obsługuje (np. własne skróty aplikacji na Ctrl+Shift+…).
        cel.addEventListener(nazwa, uchwyt, true);
        sprzatanie.push(() => cel.removeEventListener(nazwa, uchwyt, true));
    };

    if (u.blokadaF12 || u.blokadaZrodla) {
        const naKlawisz = (e) => {
            const klawisz = String(e.key || "");
            if (u.blokadaF12) {
                if (klawisz === "F12") { zablokuj(e); return; }
                // Ctrl+Shift+I / J / C — te same narzędzia, drugim skrótem. `key` przy wciśniętym Shift
                // bywa wielką literą, więc porównujemy po jednej, ujednoliconej literze.
                if (e.ctrlKey && e.shiftKey && klawisz.length === 1 && "IJC".includes(klawisz.toUpperCase())) {
                    zablokuj(e);
                    return;
                }
            }
            if (u.blokadaZrodla && e.ctrlKey && !e.shiftKey && !e.altKey && klawisz.toLowerCase() === "u") {
                // ⚠️ W polu edycji Ctrl+U to PODKREŚLENIE. Zablokowane globalnie zabrałoby podkreślanie
                // w edytorze treści (aktualności, baza wiedzy, stopki) — blokada ochroniłaby źródło strony
                // kosztem funkcji, z której ludzie korzystają codziennie.
                if (czyPoleEdycji(e.target)) return;
                zablokuj(e);
            }
        };
        nasluch(okno, "keydown", naKlawisz);
    }

    if (u.blokadaKopiowania) {
        const naKopiowanie = (e) => {
            if (czyPoleEdycji(e.target)) return;
            e.preventDefault();
        };
        // `selectstart` odbiera zaznaczanie myszą TAK SAMO jak `user-select: none`, ale jest zdarzeniem,
        // więc wyjątek dla pól formularzy jest tą samą jedną regułą co wszędzie indziej (a nie drugą,
        // osobną listą selektorów w arkuszu, którą łatwo rozjechać z tą tutaj).
        const naZaznaczenie = (e) => {
            if (czyPoleEdycji(e.target)) return;
            e.preventDefault();
        };
        nasluch(dokument, "copy", naKopiowanie);
        nasluch(dokument, "cut", naKopiowanie);
        nasluch(dokument, "selectstart", naZaznaczenie);
        if (dokument.body) {
            dokument.body.setAttribute(ATRYBUT_KOPIOWANIA, "1");
            sprzatanie.push(() => dokument.body?.removeAttribute(ATRYBUT_KOPIOWANIA));
        }
    }

    if (u.blokadaMenuKontekstowego) {
        const naMenu = (e) => {
            // Prawy przycisk w polu to „Wklej" i podpowiedzi pisowni — zabranie tego psuje pracę, a nie
            // chroni treści: w polu i tak stoi to, co człowiek sam wpisał.
            if (czyPoleEdycji(e.target)) return;
            e.preventDefault();
        };
        nasluch(dokument, "contextmenu", naMenu);
    }

    return () => {
        while (sprzatanie.length) {
            const krok = sprzatanie.pop();
            try { krok(); } catch { /* zdejmowanie nasłuchu nie ma prawa wywrócić aplikacji */ }
        }
    };
};
